"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OriginatingEntity = void 0;
let OriginatingEntity = exports.OriginatingEntity = /*#__PURE__*/function (OriginatingEntity) {
  OriginatingEntity["Bot"] = "Bot";
  OriginatingEntity["Human"] = "Human";
  return OriginatingEntity;
}({});
